import { FC } from "react";
import { UseCodeListContext } from "../Context/CodeListContext";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { UseTranslationContext } from "../Context/TranslationContext";
import { CodeListKey, SalarySimFormCodeList } from "../Model/CodeListOutput";
import InputData from "../Model/InputData";
import { ClDonneesPresta } from "../Model/PrestaData";



export const convertToHoursAndMinutesString = (totalMinutes : string) => {
    var totalMinutesNum = parseInt(totalMinutes);
    const minutes = totalMinutesNum % 60;
    const hours = Math.floor(totalMinutesNum / 60);
  
    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
  };
  

    export const toHoursAndMinutes = (totalMinutes : number) => {
        const minutes = totalMinutes % 60;
        const hours = Math.floor(totalMinutes / 60);
      
        return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
      };
      
      const padTo2Digits = (num : number) => {
        return num.toString().padStart(2, '0');
      };

    export const RecupererTypeContrat = (PrecisionCategorieContrat : number, CategorieOnss : number, CategorieContrat : number) => {
          var typeContrat = 0;

          // Administateur - 5 
          if (PrecisionCategorieContrat == 5 && CategorieOnss == 0)
              return 5;

          //  Associés actifs - 8
          if (PrecisionCategorieContrat == 30 && CategorieOnss == 0)
              return 8;

          // Ouvrier - 1 
          if (CategorieOnss == 15)
              return 1;

          //  Ouvrier contractuel subventionné (cat.ONSS 24) - 15
          if (CategorieOnss == 24)
              return 15;

          //  Ouvrier -19 ans
          if ( CategorieOnss == 27)
              return 21;

          //  Apprenti
          if (CategorieOnss == 35)
              return 11;

          //  Travailleur domestique
          if ( CategorieOnss == 45)
              return 14;

          //  Artiste
          if ( CategorieOnss == 46)
             return 13;

          //  Apprenti employé
          if ( CategorieOnss == 439)
              return 12;

          //  Gens de maison (manuel, cat.onss 43)
          if (CategorieOnss == 43)
              return 43;

          //  Employé contractuel subventionné (cat.ONSS 484)
          if (CategorieOnss == 484)
              return 16;

          //   Employé -19 ans
          if (CategorieOnss == 487)
              return 23;

          //   Sportifs rémunérés
          if (CategorieOnss == 494)
              return 48;

          //   Sportifs 19+
          if (CategorieOnss == 454)
              return 454;

          //   Employé
          if (CategorieContrat == 2 && CategorieOnss == 495)
              return 3;

          //  Gens de maisons(intellectuel, cat.onss 495)
          if (CategorieContrat == 3 && CategorieOnss == 495)
              return 495;

          // Statutaire
          if (CategorieOnss == 675)
              return 675;


          //   Etudiant (manuel)
          if (CategorieContrat == 1 && CategorieOnss == 840)
              return 6;

          //  Etudiant (intellectuel)
          if (CategorieContrat == 2 && CategorieOnss == 840)
              return 7;


          return typeContrat;

      };

      export const ImportPrestaData = (prestaData : ClDonneesPresta, codeListForm : SalarySimFormCodeList, codeListJointCommittee : CodeListKey[], codeListNSSOPrefix : CodeListKey[], getKeyFromKeyId : any, setWarningMessage : any ) => {

        //-------------------------
        let prestaConvertedData : InputData = new InputData();
        
        //------------------------
            var messageAvertissement = "";

            prestaConvertedData.UserName = prestaData.Nom + " " + prestaData.Prenom;
            prestaConvertedData.MaritalStatus = prestaData.CdEtatCivil;
            prestaConvertedData.BirthDate = prestaData.DateNaissance.toString();
            prestaConvertedData.EstablishmentUnit = prestaData.UniteEtablissement;
            prestaConvertedData.Disabled = (prestaData.CdTravailleurHandicape == 1)?true:false;
            prestaConvertedData.Spouse = prestaData.CdConjointACharge; // verifier pourquoi on est en string
            prestaConvertedData.DisabledSpouse = (prestaData.CdConjointHandicape == 1)?true:false;
    
    
            if(prestaData.NbEnfantACharge > 0 || prestaData.NbEnfantAChargeHandicape > 0 ||
                  prestaData.NbPersonneMoins65ACharge > 0 || prestaData.NbPersonneMoins65AChargeHandicape > 0 ||
                  prestaData.NbPersonnePlus65ACharge > 0 || prestaData.NbPersonnePlus65AChargeHandicape > 0
            )
            {
                prestaConvertedData.Dependant = true;
            }
            else
            {
                prestaConvertedData.Dependant = false;
            }
    
            prestaConvertedData.DependantChildren = prestaData.NbEnfantACharge;
            prestaConvertedData.DisabledDependantChildren = prestaData.NbEnfantAChargeHandicape;
    
            prestaConvertedData.OthersDependant = prestaData.NbPersonneMoins65ACharge;
            prestaConvertedData.OthersDisabledDependant = prestaData.NbPersonneMoins65AChargeHandicape;
    
            prestaConvertedData.More65TransitionalMeasureDependant = prestaData.NbPersonnePlus65ACharge;
            prestaConvertedData.More65TransitionalMeasureDisabledDependant = prestaData.NbPersonnePlus65AChargeHandicape;
    
            prestaConvertedData.More65DependanceSituationDependant = 0;
            prestaConvertedData.More65DependanceSituationDisabledDependant = 0;
    
            var auMoinsUnCPtrouve : boolean = false;
    
            if(prestaData.EltRegime != null && prestaData.EltRegime.length > 0)
            {
                
                if(prestaData.EltRegime.find(x => x.CdPrestEquipe1))
                {
                    auMoinsUnCPtrouve = true;
                }
            }
    
            if (auMoinsUnCPtrouve)
            {
                messageAvertissement += getKeyFromKeyId("CD_DETECTE_HORAIRE");
            }
    
            if (prestaData.CdTempsPleinPartiel == 1 || prestaData.CdTempsPleinPartiel == 4)
            {
                prestaConvertedData.PartTime = false;
    
                prestaConvertedData.MondaySchedule = "456"; //"07:36";
                prestaConvertedData.TuesdaySchedule = "456";
                prestaConvertedData.WednesdaySchedule = "456";
                prestaConvertedData.ThursdaySchedule = "456";
                prestaConvertedData.FridaySchedule = "456";
                prestaConvertedData.SaturdaySchedule = "0"; //"00:00"
                prestaConvertedData.SundaySchedule = "0";
                
                prestaConvertedData.MondayScheduleRef = "456";
                prestaConvertedData.TuesdayScheduleRef = "456";
                prestaConvertedData.WednesdayScheduleRef = "456";
                prestaConvertedData.ThursdayScheduleRef = "456";
                prestaConvertedData.FridayScheduleRef = "456";
                prestaConvertedData.SaturdayScheduleRef = "0";
                prestaConvertedData.SundayScheduleRef = "0";
            }
            else
            {
                // Remplir l'horaire du travailleur via les données presta si no jour <= 7
                prestaConvertedData.PartTime = true;
    
                if (prestaData.Regime.DureeJours <= 7)
                {
                    prestaConvertedData.MondaySchedule = "0";
                    prestaConvertedData.TuesdaySchedule = "0";
                    prestaConvertedData.WednesdaySchedule = "0";
                    prestaConvertedData.ThursdaySchedule = "0";
                    prestaConvertedData.FridaySchedule = "0";
                    prestaConvertedData.SaturdaySchedule = "0";
                    prestaConvertedData.SundaySchedule = "0";
    
                    prestaData.EltRegime.map((currentDay) =>
                    {
                        switch(currentDay.NoJour)
                        {
                            case 1:
                                prestaConvertedData.MondaySchedule = currentDay.DureeMinute.toString();
                                break;
                            case 2:
                                prestaConvertedData.TuesdaySchedule = currentDay.DureeMinute.toString();
                                break;
                            case 3:
                                prestaConvertedData.WednesdaySchedule = currentDay.DureeMinute.toString();
                                break;
                            case 4:
                                prestaConvertedData.ThursdaySchedule = currentDay.DureeMinute.toString();
                                break;
                            case 5:
                                prestaConvertedData.FridaySchedule = currentDay.DureeMinute.toString();
                                break;
                            case 6:
                                prestaConvertedData.SaturdaySchedule = currentDay.DureeMinute.toString();
                                break;
                            case 7:
                                prestaConvertedData.SundaySchedule = currentDay.DureeMinute.toString();
                                break;
                        }
                    });
                }
                else
                { 
                    // Horaire sur plus de 7 jours
                    //string msg = Fct.Renvoyer_Libelle(Langue, Liste_Libelle, "ERR_CHAR_HORAIRE", false);
                    var msg = getKeyFromKeyId("ERR_CHAR_HORAIRE");
    
                    var hourMinutes = "00:00";
                    if(prestaData.Regime.TotalHeures > 0)
                    {
                        hourMinutes = toHoursAndMinutes(prestaData.Regime.TotalHeures * 60); // check if correct
                        messageAvertissement += msg.replace("#valeur#", hourMinutes);
                    }
                }
            }
    
            if (prestaData.CdImportanceActuel != 0)
            {
                prestaConvertedData.NumberEmployees = prestaData.CdImportanceActuel.toString(); // vérifier correspondance
            }
            else
            {
                prestaConvertedData.NumberEmployees = "1";
            }
    
            prestaConvertedData.MonthlyAmount = prestaData.MontantBaseRemuneration; // brut salary // to check            
    
            if (prestaData.CdBaseRemuneration == 4)
            {
                //messageAvertissement += Fct.Renvoyer_Libelle(Langue, Liste_Libelle, "MSG_TRANSF_REMUN_MENSUELLE", false);
                var myMessage = getKeyFromKeyId("MSG_TRANSF_REMUN_MENSUELLE");
                messageAvertissement += myMessage;
            }
    
            try
            {
                var typeContrat = RecupererTypeContrat(prestaData.PrecisionCategorieContrat, prestaData.CategorieOnss, prestaData.CategorieContrat);
    
                if (typeContrat != 0)
                {
                    // Valider le type contrat
                    var contratValide = (codeListForm.clContrPlus.find(p => p.keyValNum == typeContrat) != undefined)?true:false;
                    //var comssionParitaireValide = (codeListJointCommittee.find(p => p.keyValNum == (parseInt(prestaData.NoComParitaire))) != undefined)?true:false;
                    //var prefixeOnssValide = codeListNSSOPrefix.find(p => p.keyValString == prestaData.PrefixeOnss);
    
                    // Valider 
                    if (contratValide)
                    {
                        prestaConvertedData.ContractType = typeContrat;
                    }
    
                    //if (comssionParitaireValide)
                    {
                        //Gerer_Affichage_Statutaire_Ibrunet_Plus(donneesPresta.CategorieContrat); // géré dans la step adaptée
                        prestaConvertedData.JointCommittee = prestaData.NoComParitaire;
                    }
    
                    //if (prefixeOnssValide)
                    {
                        prestaConvertedData.OnssPrefix = prestaData.PrefixeOnss;
                    }
                }
            }
            catch
            {
    
            }
    
            prestaConvertedData.OnssSubmitted = (prestaData.CdSoumisOnss == 0)?false:true; // vérifier
    
            // vérifier méthode horaire employeur
    
            // Code liste formulaire plus restreinte que Presta, donc si code = 2,4,5-- > Non résident / Si 1,3,6-- > Soumis / Si NULL ou 0-- > Non soumis
            switch (prestaData.CdSoumisPrecompte)
            {
                case 2:
                case 4:
                case 5:
                    prestaConvertedData.ProfDeductionSubmitted = "2";
                    break;
    
                case 1:
                case 3:
                case 6:
                    prestaConvertedData.ProfDeductionSubmitted = "1";
                    break;
    
                default:
                    prestaConvertedData.ProfDeductionSubmitted = "0";
                    break;
            }
    
    
            // Remplir l'horaire de l'employeur
            if (prestaData.EltRegimeEmployeur != null && prestaData.EltRegimeEmployeur.length > 0)
            {
                prestaConvertedData.MondayScheduleRef = "0";
                prestaConvertedData.TuesdayScheduleRef = "0";
                prestaConvertedData.WednesdayScheduleRef = "0";
                prestaConvertedData.ThursdayScheduleRef = "0";
                prestaConvertedData.FridayScheduleRef = "0";
                prestaConvertedData.SaturdayScheduleRef = "0";
                prestaConvertedData.SundayScheduleRef = "0";
    
                prestaData.EltRegimeEmployeur.map((currentDay) => {
                    switch(currentDay.NoJour)
                    {
                        case 1:
                            prestaConvertedData.MondayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                        case 2:
                            prestaConvertedData.TuesdayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                        case 3:
                            prestaConvertedData.WednesdayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                        case 4:
                            prestaConvertedData.ThursdayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                        case 5:
                            prestaConvertedData.FridayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                        case 6:
                            prestaConvertedData.SaturdayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                        case 7:
                            prestaConvertedData.SundayScheduleRef = currentDay.DureeMinute.toString();
                            break;
                    }
                });
            }

            /*
            GroupTabPanel_Ibrunet_Application.SetActiveGroup(1);
            GroupTabPanel_Ibrunet_Application.SetActiveTab(1);
            */
    
            //MessageErreur.Text = messageAvertissement;
            setWarningMessage(messageAvertissement);

            return prestaConvertedData;
    
        };